

export const mapAccessToken = "pk.eyJ1IjoibXVkaXRnb2VsMzAxMSIsImEiOiJja3owMDRleXowZmxhMnBvMDB3bHZ3bGRzIn0.G4VeYTsyIBmj9CGeG7VB6Q";

//fetch weather data from Weather.com's API
export const weatherApiKey = "2ec2232d72f1484282232d72f198421d";
export const weatherTileServerUrl = `https://api.weather.com/v3/TileServer/series/productSet/PPAcore?apiKey=${weatherApiKey}`;